export const ASYNC_TASK_INTERVAL = 3000
